import { CurrencyPipe, registerLocaleData } from '@angular/common';
import {
  provideHttpClient,
  withInterceptorsFromDi,
  HTTP_INTERCEPTORS,
} from '@angular/common/http';
import {
  ApplicationConfig,
  provideZoneChangeDetection,
  provideAppInitializer,
  inject,
  LOCALE_ID,
} from '@angular/core';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideRouter } from '@angular/router';
import { APP_ROUTES } from '@app/app.routes';

import localeDe from '@angular/common/locales/de';
import localeHr from '@angular/common/locales/hr';
import localeEn from '@angular/common/locales/en';
import localeSe from '@angular/common/locales/se';
import localePt from '@angular/common/locales/pt';
import localeFr from '@angular/common/locales/fr';
import localeSv from '@angular/common/locales/sv';
import localeEs from '@angular/common/locales/es';
import { AuthInterceptor } from '@interceptors/auth.interceptor';
import { WindowWithUser } from '@longnecktech/splash-commons-fe';
import { GameService } from '@services/game.service';
import { SessionService } from '@services/session.service';
import { TranslationService } from '@services/translation.service';
import { getTokenParams } from '@shared/utils/get-token-params';
import player from 'lottie-web/build/player/lottie_svg';
import { provideLottieOptions } from 'ngx-lottie';
import { firstValueFrom } from 'rxjs';

export function startupServiceFactory(
  sessionService: SessionService,
  gameService: GameService,
) {
  return async () => {
    const params = getTokenParams();
    sessionService.thirdPartyToken = params.token;
    sessionService.instance = params.instance;
    sessionService.gameUuid = params.gameUuid;
    sessionService.isFromHub = params.isFromHub;
    sessionService.hubGameUuid = params.hubGameUuid;
    sessionService.setUser((window as WindowWithUser).user);
    await firstValueFrom(gameService.fetchGame());
  };
}

registerLocaleData(localeEn, 'en');
registerLocaleData(localeHr, 'hr');
registerLocaleData(localeDe, 'de');
registerLocaleData(localeEs, 'es');
registerLocaleData(localePt, 'pt');
registerLocaleData(localeSv, 'sv');
registerLocaleData(localeFr, 'fr');
registerLocaleData(localeSe, 'se');

export function localeFactory() {
  const lang = (window as WindowWithUser).user.language || 'en';
  return TranslationService.supportedLanguages.includes(lang) ? lang : 'en';
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(APP_ROUTES),
    provideAnimations(),
    provideHttpClient(withInterceptorsFromDi()),
    CurrencyPipe,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true,
    },
    {
      provide: LOCALE_ID,
      useFactory: localeFactory,
    },
    provideLottieOptions({
      player: () => player,
    }),
    provideAppInitializer(() => {
      const initializerFn = startupServiceFactory(
        inject(SessionService),
        inject(GameService),
      );
      return initializerFn();
    }),
  ],
};
